export default function IconBox({ icon, title, description }) {
  return <article className="amenity-card"><span className="amenity-icon" aria-hidden="true">{icon}</span><h3>{title}</h3><p>{description}</p></article>;
}
